/* eslint-disable no-unused-vars */
import {
  Box,
  Button,
  Flex,
  HStack,
  Icon,
  SimpleGrid,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { useContext } from "react";

import { useNavigate } from "react-router-dom";
import CustomModal from "../../Components/Common/CustomModal/CustomModal";
import EdssPopup from "../../Components/Eddss/EdssPopup";
import SearchPerson from "../../Components/Eddss/SearchPerson";
import { AuthContext } from "../../Context/AuthProvider";
import { useFetchDashboardData } from "../../hooks/useFetchDashboardData";
// import { demoRecentUserCases } from "../../utils/demoData";
import { Icons } from "../../WinterCountIconFIle";
import CreateNewCaseForm from "./CreateNewCaseForm";
import RecentAssignmentTable from "./RecentAssignmentsTable";
import RecentCaseTable from "./RecentCaseTable";
import RecentlyMergedTable from "./RecentlyMergedTable";

const SectionCard = ({ title, children }) => (
  <Box
    bg="white"
    borderRadius="2xl"
    boxShadow="0 4px 24px rgba(0,0,0,0.10)"
    transition="box-shadow 0.2s ease"
    _hover={{ boxShadow: "0 8px 32px rgba(0,0,0,0.15)" }}
  >
    <Box
      px={5}
      py={4}
      borderBottomWidth="1px"
      borderColor="gray.100"
      bg="white"
      borderTopRadius="2xl"
    >
      <Text
        fontSize="sm"
        fontWeight="600"
        letterSpacing="0.06em"
        textTransform="uppercase"
        color="gray.500"
      >
        {title}
      </Text>
    </Box>
    <Box borderBottomRadius="2xl" overflow="hidden" px={1}>
      {children}
    </Box>
  </Box>
);

const EdssPage = () => {
  const { isAdmin, isDedupAvailable } = useContext(AuthContext);
  const { onOpen, isOpen, onClose } = useDisclosure();
  const {
    onOpen: onSearchPersonOpen,
    isOpen: isSearchPersonOpen,
    onClose: onSearchPersonClose,
  } = useDisclosure();
  const {
    onOpen: onNewCaseOpen,
    isOpen: isNewCaseOpen,
    onClose: onNewCaseClose,
  } = useDisclosure();

  const {
    recentCases,
    activeAssignments,
    recentlyMergedUsers,
    loadingCases,
    loadingAssignments,
    loadingMerges,
    errorCases,
    errorAssignments,
    errorMerges,
    fetchMoreCases,
    fetchMoreAssignments,
    fetchMoreMerges,
  } = useFetchDashboardData();

  const navigate = useNavigate();
  const handleNavigation = (caseItem) => {
    localStorage.setItem("recentClickCase", JSON.stringify(caseItem));
    navigate(`/CaseView/${caseItem?.id}/${caseItem?.PERSON_ID}`);
  };

  return (
    <Box
      minH="100vh"
      bg="gray.50"
      px={{ base: 2, md: 2 }}
      py={4}
      fontFamily="'DM Sans', sans-serif"
    >
      {/* Header */}
      <Flex
        align="center"
        justify="space-between"
        mb={3}
        flexWrap="wrap"
        gap={4}
      >
        <Box>
          <Text fontSize="2xl" fontWeight="700" color="gray.800" lineHeight="1">
            Investigate Dashboard
          </Text>
          <Text fontSize="sm" color="gray.400" mt={1}>
            Manage cases, assignments, and records
          </Text>
        </Box>

        <HStack spacing={3}>
          <Button
            leftIcon={<Icon as={Icons.SearchIcon} boxSize={4} />}
            onClick={onOpen}
            size="sm"
            bg="gray.800"
            color="white"
            borderRadius="sm"
            fontWeight="500"
            px={5}
            _hover={{ bg: "gray.700" }}
            _active={{ bg: "gray.900" }}
          >
            Search EDSS
          </Button>
          <Button
            leftIcon={<Icon as={Icons.CreateNewIcon} boxSize={4} />}
            onClick={onNewCaseOpen}
            size="sm"
            bg="teal.500"
            color="white"
            borderRadius="sm"
            fontWeight="500"
            px={5}
            _hover={{ bg: "teal.400" }}
            _active={{ bg: "teal.600" }}
          >
            Create New
          </Button>
          <Button
            leftIcon={<Icon as={Icons.UserSearchIcon} boxSize={4} />}
            onClick={onSearchPersonOpen}
            size="sm"
            borderColor="gray.300"
            color="gray.600"
            borderRadius="sm"
            fontWeight="500"
            px={5}
            _hover={{ bg: "gray.100", borderColor: "gray.400" }}
          >
            Search Person
          </Button>
        </HStack>
      </Flex>

      {/* Tables Grid */}
      <SimpleGrid
        columns={{ base: 1, md: isAdmin || isDedupAvailable ? 3 : 2 }}
        spacing={3}
      >
        <SectionCard title="Recent Cases Viewed">
          <RecentCaseTable
            isLoading={loadingCases}
            recentCases={recentCases}
            // recentCases={demoRecentUserCases}
            handleNavigation={handleNavigation}
            fetchMoreCases={fetchMoreCases}
            errorCases={errorCases}
          />
        </SectionCard>

        <SectionCard title="Assigned Cases">
          <RecentAssignmentTable
            isLoading={loadingAssignments}
            data={activeAssignments}
            // data={demoRecentUserCases}
            errorAssignments={errorAssignments}
            handleNavigation={handleNavigation}
            fetchMoreAssignments={fetchMoreAssignments}
          />
        </SectionCard>

        {(isAdmin || isDedupAvailable) && (
          <SectionCard title="Recently Merged">
            <RecentlyMergedTable
              isLoading={loadingMerges}
              data={recentlyMergedUsers}
              // data={demoRecentUserCases}
              fetchMoreMerges={fetchMoreMerges}
              errorMerges={errorMerges}
            />
          </SectionCard>
        )}
      </SimpleGrid>

      {/* Modals */}
      <CustomModal
        size="6xl"
        isCentered
        title="Search Person"
        isOpen={isSearchPersonOpen}
        onClose={onSearchPersonClose}
        bodyContent={<SearchPerson onClose={onSearchPersonClose} />}
      />
      <CustomModal
        size="6xl"
        isCentered
        title="Search EDSS"
        isOpen={isOpen}
        onClose={onClose}
        bodyContent={<EdssPopup onClose={onClose} />}
      />
      <CustomModal
        size="6xl"
        isCentered
        title="Create New Case"
        isOpen={isNewCaseOpen}
        onClose={onNewCaseClose}
        bodyContent={<CreateNewCaseForm onClose={onNewCaseClose} />}
      />
    </Box>
  );
};

export default EdssPage;
